import { IconAutoZoom, IconCameraLock, IconCameraUnlock } from "./TimelineTransportIcons";

interface TimelineTransportTogglesProps {
  cameraLockEnabled: boolean;
  autoZoomEnabled: boolean;
  onCameraLockToggle: () => void;
  onAutoZoomToggle: () => void;
}

export function TimelineTransportToggles({
  cameraLockEnabled,
  autoZoomEnabled,
  onCameraLockToggle,
  onAutoZoomToggle,
}: TimelineTransportTogglesProps) {
  return (
    <>
      <button
        type="button"
        className={toggleClass(cameraLockEnabled)}
        onClick={onCameraLockToggle}
        aria-pressed={cameraLockEnabled}
        aria-label="Camera lock"
        title="Camera lock"
      >
        {cameraLockEnabled ? (
          <IconCameraLock className="timeline-transport__icon" />
        ) : (
          <IconCameraUnlock className="timeline-transport__icon" />
        )}
      </button>
      <button
        type="button"
        className={toggleClass(autoZoomEnabled)}
        onClick={onAutoZoomToggle}
        aria-pressed={autoZoomEnabled}
        aria-label="Auto zoom"
        title="Auto zoom"
      >
        <IconAutoZoom className="timeline-transport__icon" />
      </button>
    </>
  );
}

function toggleClass(on: boolean): string {
  return on
    ? "timeline-transport__btn timeline-transport__btn--toggle-on"
    : "timeline-transport__btn";
}
